import React, { useState, useEffect } from 'react'
import { reactRender } from 'reusable/react-render/react-render'
import { Root } from 'react-dom/client'
import { LoadingModal } from './LoadingModal'

export async function executeLoading<T>(
   message: string,
   action: () => Promise<T> | T
) {
   return new Promise<T>((resolve, reject) => {
      reactRender((container, root) =>
         <LoadingModalExecute container={container} root={root} title={message} resolve={resolve} action={action} />,
      )
   })
}

interface LoadingModalExecuteProps<T> {
   container?: HTMLElement
   root?: Root
   title?: string
   resolve: (value: T | PromiseLike<T>) => void
   action: () => Promise<T> | T
}

function LoadingModalExecute<T>(props: LoadingModalExecuteProps<T>) {
   const [visible, setVisible] = useState(true)
   const { resolve, action } = props

   useEffect(() => {
      async function run() {
         try {
            const x = async () => await action()
            resolve(await x())
         } catch (error) {
            setVisible(false)
            throw error
         }
         setVisible(false)
      }
      setTimeout(run)
      //run()
   }, [resolve, action])

   return <LoadingModal {...props} visible={visible} />
}
